<template>
  <div class="app">
    <div class="table">
      <ux-grid ref="table" widthResize show-overflow="title" :data="tableData" border stripe :height="uxGridHeight" max-height="100%" style="width: 100%" @cell-click="tableCellClick" v-loading="tableLoading" :row-class-name="tableRowClassName">
        <ux-table-column type="index" width="30" align="center" fixed="left" class-name="table-index" resizable>
          <template slot="header">
            <el-tooltip class="item" effect="dark" content="设置隐藏列(点击显示/隐藏)" placement="top">
              <el-button icon="el-icon-s-tools" type="text" @click="getCustomColumns"></el-button>
            </el-tooltip>
          </template>
        </ux-table-column>
        <ux-table-column title="操作" align="center" :width="power.activeName.match(/first|fourth/i) ? 140 : 110" fixed="left" resizable>
          <template slot-scope="scope">
            <el-button v-if="power.activeName.match(/first|fourth/i)" icon="el-icon-plus" type="text" :style="scope.rowIndex + 1 == tableData.length ? 'color: red' : ''" @click="addRow(scope.rowIndex + 1)"></el-button>
            <el-button v-if="power.activeName.match(/first|fourth/i)" icon="el-icon-delete" type="text" style="margin: 0;" @click="deleteRow(scope)"></el-button>
            <el-tooltip class="item" effect="dark" :content="scope.row.itemName + '在第' + scope.row.mergeIndex + '行已经录入'" placement="right" :enterable="false" offset="20">
              <el-button v-show="power.activeName.match(/first|fourth/i) && scope.row.isMerge" icon="iconfont icon-hebing" type="text" style="margin: 0;" @click="mergeRow(scope, power.activeName != 'fourth' ? 'salUnitQty' : 'adjustQty4Sal')"></el-button>
            </el-tooltip>
            <el-button type="text" style="margin: 0; color: #909399;" @click="inventory(0, scope)">未盘</el-button>
            <el-button type="text" style="margin: 0;" @click="inventory(1, scope)">盘平</el-button>
            <el-button type="text" style="margin: 0; color: #F56C6C;" @click="inventory(2, scope)">盘空</el-button>
          </template>
        </ux-table-column>
        <ux-table-column title="商品" field="itemName" width="200" align="center" fixed="left" resizable>
          <template slot-scope="scope">
            <div v-if="scope.row.isShowItemName && power.activeName.match(/first|fourth/i) && !scope.row.id">
              <select-multiple :select-data="itemName" :optionKey="itemNameOptionKey" :isSlot="true" :isClear="false" :change="(val, row) => { itemNameChange(val, scope, power.activeName != 'fourth' ? 'salUnitQty' : 'adjustQty4Sal') }" :visible-change="(val, row) => { itemNameVisibleChange(val, scope) }" v-focus @keydown.enter.right.native="itemNameVisibleChange(false, scope, power.activeName != 'fourth' ? 'salUnitQty' : 'adjustQty4Sal')" @keyup.shift.up.native="tableSelectUpOrDown(scope, scope.column.property, scope.rowIndex - 1)" @keyup.shift.down.native="tableSelectUpOrDown(scope, scope.column.property, scope.rowIndex + 1)">
                <template #header>
                  <li class="el-select-group__title" style="color: #000; font-weight: bold; font-size: 14px;">
                    <span style="width: 180px;display: inline-block;">商品</span>
                    <span style="width: 100px;display: inline-block;">规格</span>
                    <span style="width: 100px;display: inline-block;">库存数</span>
                    <span style="width: 100px;display: inline-block;">可用数</span>
                    <span style="width: 100px;display: inline-block;" v-if="store.power.isEnableProductDate == 'Y'">生产日期</span>
                  </li>
                </template>
                <template v-slot:default='slotProps'>
                  <div style="flex: 1; display: flex; align-items: center;">
                    <span style="width: 180px;text-wrap: initial;word-wrap:break-word;word-break:break-all;white-space:normal;">{{ slotProps.item.itemName }}</span>
                    <span style="width: 100px;display: inline-block;">{{ slotProps.item.itemSpec }}</span>
                    <span style="width: 100px;display: inline-block;">{{ slotProps.item.onhandQtyQtyFormat }}</span>
                    <span style="width: 100px;display: inline-block;">{{ slotProps.item.availableQtyFormat }}</span>
                    <span style="width: 100px;display: inline-block;">{{ slotProps.item.productionDate }}</span>
                  </div>
                </template>
              </select-multiple>
            </div>
            <div v-else>
              <span>{{ scope.row.itemName }}</span>
              <div v-if="scope.row.itemName" style="display: flex; justify-content: center; align-items: center;">
                <el-tag size="mini" style="margin-right: 12px;" :type="scope.row.checkedStatus == 'Y' ? profitAndlossStatus[scope.row.profitAndlossStatus].type : 'info'">{{ scope.row.checkedStatus == 'Y' ? profitAndlossStatus[scope.row.profitAndlossStatus].text : '未盘' }}</el-tag>
                <!-- <span>{{ scope.row.itemSpec }}</span> -->
              </div>
            </div>
          </template>
        </ux-table-column>
        <ux-table-column resizable title="规格" field="itemSpec" align="center" width="100"></ux-table-column>
        <ux-table-column resizable title="订单占用数" field="onLoadQtyFormat" align="center" width="100">
          <template slot-scope="scope">
            <div v-if="scope.row.itemName">
              <el-button type="text" @click="viewInvOnLoadQty(scope.row)" v-if="scope.row.onLoadQty > 0">{{ scope.row.onLoadQtyFormat }}</el-button>
              <span v-else>无</span>
            </div>
          </template>
        </ux-table-column>
        <!-- <ux-table-column title="规格" field="itemSpec" width="100" align="center" resizable></ux-table-column> -->
        <ux-table-column title="账面数" field="onhandQtyFormat" align="center" resizable width="120">
          <template slot-scope="scope">
            <div v-if="scope.row.itemName">
              <div class="qty-wrap" :style="store.power.showInvUnitNum == 'Y' ? '' : 'border: none;'">
                <span v-if="scope.row.salUnitName">
                  <span>{{ Number(scope.row.onhandQty4Sal) || 0 }}</span>
                  <span class="unit" style="margin: 0 2px;">{{ scope.row.salUnitName }}</span>
                </span>
                <span v-if="scope.row.midUnitName">
                  <span>{{ Number(scope.row.onhandQty4Mid) || 0 }}</span>
                  <span class="unit" style="margin: 0 2px;">{{ scope.row.midUnitName }}</span>
                </span>
                <span v-if="scope.row.salUnitConversion != 1 && scope.row.invUnitName">
                  <span>{{ Number(scope.row.onhandQty4Inv) || 0 }}</span>
                  <span class="unit" style="margin-left: 2px;">{{ scope.row.invUnitName }}</span>
                </span>
              </div>
              <p style="font-size: 12px; color: #F56C6C;" v-if="store.power.showInvUnitNum == 'Y'">
                <span>折算:</span>
                <span>{{ scope.row.onhandQty || 0 }}</span>
                <span>{{ scope.row.invUnitName }}</span>
              </p>
            </div>
          </template>
        </ux-table-column>
        <ux-table-column v-if="power.activeName != 'fourth'" title="盘点数" align="center" resizable width="140">
          <template slot-scope="scope">
            <div v-if="scope.row.itemName">
              <div class="qty-wrap" :style="store.power.showInvUnitNum == 'Y' ? '' : 'border: none;'">
                <p>
                  <span v-if="scope.row.salUnitName">
                    <el-input-number size="mini" class="qty-input" v-model="scope.row.salUnitQty" v-if="scope.row.isShowSalUnitQty" v-focus :controls="false" :precision="2" :step="0" @blur="numberInputBlur(scope, 'salUnitQty')" @keydown.enter.right.native="numberInputBlur(scope, 'salUnitQty', scope.row.midUnitName ? 'midUnitQty' : (scope.row.salUnitConversion != 1 ? 'invUnitQty' : (power.activeName.match(/first|fourth/i) ? 'adjustQty4Sal' : 'remark')))" @change="numberInputChange($event, scope)" @keydown.left.native="numberInputBlur(scope, 'salUnitQty', 'itemName')" @keydown.up.native="numberInputBlur(scope, 'salUnitQty', 'salUnitQty', scope.rowIndex - 1)" @keydown.down.native="numberInputBlur(scope, 'salUnitQty', 'salUnitQty', scope.rowIndex + 1)"></el-input-number>
                    <span class="qty" v-else @click="tableCellClick(scope.row, { property: 'salUnitQty' })">{{ Number(scope.row.salUnitQty) || 0 }}</span>
                    <span class="unit">{{ scope.row.salUnitName }}</span>
                  </span>
                  <span v-if="scope.row.midUnitName">
                    <el-input-number size="mini" class="qty-input" v-model="scope.row.midUnitQty" v-if="scope.row.isShowMidUnitQty" v-focus :controls="false" :precision="2" :step="0" @blur="numberInputBlur(scope, 'midUnitQty')" @keydown.enter.right.native="numberInputBlur(scope, 'midUnitQty', scope.row.salUnitConversion != 1 ? 'invUnitQty' : 'remark')"  @keydown.left.native="numberInputBlur(scope, 'midUnitQty', scope.row.salUnitName ? 'salUnitQty' : 'midUnitQty')" @change="numberInputChange($event, scope)" @keydown.up.native="numberInputBlur(scope, 'midUnitQty', 'salUnitQty', scope.rowIndex - 1)" @keydown.down.native="numberInputBlur(scope, 'midUnitQty', 'salUnitQty', scope.rowIndex + 1)"></el-input-number>
                    <span class="qty" v-else @click="tableCellClick(scope.row, { property: 'midUnitQty' })">{{ Number(scope.row.midUnitQty) || 0 }}</span>
                    <span class="unit">{{ scope.row.midUnitName }}</span>
                  </span>
                </p>
                <span v-if="scope.row.salUnitConversion != 1 && scope.row.invUnitName">
                  <el-input-number size="mini" class="qty-input" v-model="scope.row.invUnitQty" v-if="scope.row.isShowInvUnitQty" v-focus :controls="false" :precision="2" :step="0" @blur="numberInputBlur(scope, 'invUnitQty')" @keydown.enter.right.native="numberInputBlur(scope, 'invUnitQty', power.activeName.match(/first|fourth/i) ? 'adjustQty4Sal' : 'remark')" @keydown.left.native="numberInputBlur(scope, 'invUnitQty', scope.row.midUnitName ? 'midUnitQty' : 'salUnitQty')" @change="numberInputChange($event, scope)" @keydown.up.native="numberInputBlur(scope, 'invUnitQty', 'salUnitQty', scope.rowIndex - 1)" @keydown.down.native="numberInputBlur(scope, 'invUnitQty', 'salUnitQty', scope.rowIndex + 1)"></el-input-number>
                  <span class="qty" v-else @click="tableCellClick(scope.row, { property: 'invUnitQty' })">{{ Number(scope.row.invUnitQty) || 0 }}</span>
                  <span class="unit">{{ scope.row.invUnitName }}</span>
                </span>
              </div>
              <p style="font-size: 12px; color: #F56C6C;" v-if="store.power.showInvUnitNum == 'Y'">
                <span>折算:</span>
                <span>{{ scope.row.realQty || 0 }}</span>
                <span>{{ scope.row.invUnitName }}</span>
              </p>
            </div>
          </template>
        </ux-table-column>
        <ux-table-column v-if="power.activeName.match(/first|fourth/i)" key="adjustQty1" :title="power.activeName == 'first' ? '调整数' : '报损数'" align="center" resizable width="140">
          <template slot-scope="scope">
            <div v-if="scope.row.itemName">
              <div class="qty-wrap" :style="store.power.showInvUnitNum == 'Y' ? '' : 'border: none;'">
                <p>
                  <span v-if="scope.row.salUnitName">
                    <el-input-number size="mini" class="qty-input" v-model="scope.row.adjustQty4Sal" v-if="scope.row.isShowAdjustQty4Sal" v-focus :controls="false" :precision="2" :step="0" @blur="numberInputBlur(scope, 'adjustQty4Sal')" @keydown.enter.right.native="numberInputBlur(scope, 'adjustQty4Sal', scope.row.midUnitName ? 'adjustQty4Mid' : (scope.row.salUnitConversion != 1 ? 'adjustQty4Inv' : 'remark'))" @change="numberInputChange($event, scope, 'adjustQty')" @keydown.left.native="numberInputBlur(scope, 'adjustQty4Sal', power.activeName != 'fourth' ? (scope.row.salUnitConversion != 1 ? 'invUnitQty' : (scope.row.midUnitName ? 'midUnitQty' : 'salUnitQty')) : 'itemName')" @keydown.up.native="numberInputBlur(scope, 'adjustQty4Sal', 'adjustQty4Sal', scope.rowIndex - 1)" @keydown.down.native="numberInputBlur(scope, 'adjustQty4Sal', 'adjustQty4Sal', scope.rowIndex + 1)"></el-input-number>
                    <span class="qty" v-else @click="tableCellClick(scope.row, { property: 'adjustQty4Sal' })">{{ Number(scope.row.adjustQty4Sal) || 0 }}</span>
                    <span class="unit">{{ scope.row.salUnitName }}</span>
                  </span>
                  <span v-if="scope.row.midUnitName">
                    <el-input-number size="mini" class="qty-input" v-model="scope.row.adjustQty4Mid" v-if="scope.row.isShowAdjustQty4Mid" v-focus :controls="false" :precision="2" :step="0" @blur="numberInputBlur(scope, 'adjustQty4Mid')" @keydown.enter.right.native="numberInputBlur(scope, 'adjustQty4Mid', scope.row.salUnitConversion != 1 ? 'adjustQty4Inv' : 'remark')"  @keydown.left.native="numberInputBlur(scope, 'adjustQty4Mid', scope.row.salUnitName ? 'adjustQty4Sal' : 'adjustQty4Mid')" @change="numberInputChange($event, scope, 'adjustQty')" @keydown.up.native="numberInputBlur(scope, 'adjustQty4Mid', 'adjustQty4Sal', scope.rowIndex - 1)" @keydown.down.native="numberInputBlur(scope, 'adjustQty4Mid', 'adjustQty4Sal', scope.rowIndex + 1)"></el-input-number>
                    <span class="qty" v-else @click="tableCellClick(scope.row, { property: 'adjustQty4Mid' })">{{ Number(scope.row.adjustQty4Mid) || 0 }}</span>
                    <span class="unit">{{ scope.row.midUnitName }}</span>
                  </span>
                </p>
                <span v-if="scope.row.salUnitConversion != 1 && scope.row.invUnitName">
                  <el-input-number size="mini" class="qty-input" v-model="scope.row.adjustQty4Inv" v-if="scope.row.isShowAdjustQty4Inv" v-focus :controls="false" :precision="2" :step="0" @blur="numberInputBlur(scope, 'adjustQty4Inv')" @keydown.enter.right.native="numberInputBlur(scope, 'adjustQty4Inv', 'remark')" @keydown.left.native="numberInputBlur(scope, 'adjustQty4Inv', scope.row.midUnitName ? 'adjustQty4Mid' : 'adjustQty4Sal')" @change="numberInputChange($event, scope, 'adjustQty')" @keydown.up.native="numberInputBlur(scope, 'adjustQty4Inv', 'adjustQty4Sal', scope.rowIndex - 1)" @keydown.down.native="numberInputBlur(scope, 'adjustQty4Inv', 'adjustQty4Sal', scope.rowIndex + 1)"></el-input-number>
                  <span class="qty" v-else @click="tableCellClick(scope.row, { property: 'adjustQty4Inv' })">{{ Number(scope.row.adjustQty4Inv) || 0 }}</span>
                  <span class="unit">{{ scope.row.invUnitName }}</span>
                </span>
              </div>
              <p style="font-size: 12px; color: #F56C6C;" v-if="store.power.showInvUnitNum == 'Y'">
                <span>折算:</span>
                <span>{{ scope.row.adjustQty || 0 }}</span>
                <span>{{ scope.row.invUnitName }}</span>
              </p>
            </div>
          </template>
        </ux-table-column>
        <ux-table-column v-else key="adjustQty" title="差量" align="center" resizable width="100">
        <!-- <ux-table-column key="adjustQty" title="差量" align="center" resizable v-if="store.power.isShowCheckTotalAmt == 'Y'" width="100"> -->
          <template slot-scope="scope">
            <div v-if="scope.row.itemName">
              <!-- <span>{{ scope.row.adjustQty || 0 }}</span> -->
              <span v-if="scope.row.salUnitName">
                <span>{{ Number(scope.row.adjustQty4Sal) || 0 }}</span>
                <span class="unit" style="margin: 0 2px;">{{ scope.row.salUnitName }}</span>
              </span>
              <span v-if="scope.row.midUnitName">
                <span>{{ Number(scope.row.adjustQty4Mid) || 0 }}</span>
                <span class="unit" style="margin: 0 2px;">{{ scope.row.midUnitName }}</span>
              </span>
              <span v-if="scope.row.salUnitConversion != 1 && scope.row.invUnitName">
                <span>{{ Number(scope.row.adjustQty4Inv) || 0 }}</span>
                <span class="unit" style="margin-left: 2px;">{{ scope.row.invUnitName }}</span>
              </span>
            </div>
          </template>
        </ux-table-column>
        <ux-table-column key="amt" :title="`差额(${ store.power.invCheckUsePrice == 'A' ? '成本价' : '销售价' })`" field="amt" align="center" width="100" resizable v-if="isShowCheckTotalAmt">
          <template slot-scope="scope">
            <div v-if="scope.row.itemName">
              <span>{{ scope.row.amt || 0 }}</span>
            </div>
          </template>
        </ux-table-column>
        <!-- <ux-table-column resizable title="状态" field="checkedStatus" width="100" align="center">
          <template slot-scope="scope">
            <div v-if="scope.row.itemName">
              <el-tag :type="scope.row.checkedStatus == 'Y' ? profitAndlossStatus[scope.row.profitAndlossStatus].type : 'info'">{{ scope.row.checkedStatus == 'Y' ? profitAndlossStatus[scope.row.profitAndlossStatus].text : '未盘' }}</el-tag>
            </div>
          </template>
        </ux-table-column> -->
        <ux-table-column title="条码" field="invBarCode" width="130" align="center" resizable v-if="customColumnList['invBarCode'] == 'Y'">
          <template slot-scope="scope">
            <div v-if="scope.row.salBarCode">
              <span>{{ scope.row.salBarCode }}</span><span>/大</span>
            </div>
            <div v-if="scope.row.midBarCode">
              <span>{{ scope.row.midBarCode }}</span><span>/中</span>
            </div>
            <div v-if="scope.row.invBarCode">
              <span>{{ scope.row.invBarCode }}</span><span>/小</span>
            </div>
          </template>
        </ux-table-column>
        <ux-table-column key="productionDate" title="生产日期" field="productionDate" align="center" resizable v-if="store.power.isEnableProductDate == 'Y' && customColumnList['productionDate'] == 'Y'" width="100">
          <template slot-scope="scope">
            <div v-if="scope.row.isShowProductionDate && scope.row.itemName && power.activeName.match(/first|fourth/i)">
              <el-date-picker
                style="width: 100%;"
                v-focus @blur="numberInputBlur(scope, 'productionDate')"
                value-format="yyyy-MM-dd"
                v-model="scope.row.productionDate"
                type="date"
                placeholder="选择生产日期"
                @change="productionDateChange($event, scope)">
              </el-date-picker>
            </div>
            <span v-else>{{ scope.row.productionDate }}</span>
          </template>
        </ux-table-column>
        <ux-table-column resizable title="近三次盘点数" align="center" width="100">
          <template slot-scope="scope">
            <el-popover
              v-if="scope.row.itemName"
              placement="right"
              trigger="click">
              <el-table :data="viewInv.tableData" v-loading="viewInv.loading" border stripe>
                <el-table-column width="100" property="entryDate" label="日期"></el-table-column>
                <el-table-column width="100" property="realQty" label="数量"></el-table-column>
              </el-table>
              <el-button type="text" slot="reference" icon="el-icon-view" @click="viewInvNum(scope.row)">查看</el-button>
            </el-popover>
          </template>
        </ux-table-column>
        <ux-table-column resizable title="备注" field="remark" align="center">
          <template slot-scope="scope">
            <div v-if="scope.row.itemName && scope.row.isShowRemark">
              <el-input v-model="scope.row.remark" v-focus @blur="numberInputBlur(scope, 'remark')" @keydown.enter.right.native="numberInputBlur(scope, 'remark', 'itemName', scope.rowIndex + 1)" @keydown.left.native="numberInputBlur(scope, 'remark', power.activeName.match(/first|fourth/i) ? (scope.row.salUnitConversion != 1 ? 'adjustQty4Inv' : (scope.row.midUnitName ? 'adjustQty4Mid' : 'adjustQty4Sal')) : (scope.row.salUnitConversion != 1 ? 'adjustQty4Inv' : (scope.row.midUnitName ? 'adjustQty4Mid' : 'adjustQty4Sal')), scope.rowIndex)" @keyup.up.native="tableSelectUpOrDown(scope, scope.column.property, scope.rowIndex - 1)" @keyup.down.native="tableSelectUpOrDown(scope, scope.column.property, scope.rowIndex + 1)"></el-input>
            </div>
            <span v-else>{{scope.row.remark}}</span>
          </template>
        </ux-table-column>
      </ux-grid>
    </div>
    <div class="footer">
      <span v-if="isShowCheckTotalAmt">
        <span>盘盈</span>
        <span class="text">{{ sum.invCheckProfitAmt }}</span>
        <span>盘亏</span>
        <span class="text">{{ sum.invCheckLossAmt }}</span>
        <span>合计</span>
        <span class="text">{{ sum.totalAmt }}</span>
      </span>
      <span v-else></span>
      <div>
        <el-button size="medium" v-if="power.activeName.match(/second/i)" @click="diskEmpty">一键盘空</el-button>
        <el-button size="medium" @click="submitOrser(0)">保存草稿并新建</el-button>
        <el-button size="medium" v-if="btnPower.isRecord == 'Y'" type="primary" @click="submitOrser(1)">提交审核</el-button>
        <el-button size="medium" v-if="power.activeName.match(/first|fourth/i)" @click="clearTable">清空列表</el-button>
      </div>
    </div>
    <el-dialog title="自定义显示列" :visible.sync="dialogVisible" width="20%" @close="dialogClose">
      <custom-columns ref="customColumns" v-if="dialogVisible"></custom-columns>
    </el-dialog>
  </div>
</template>

<script>
import { toFixedRe, debounce, toRawType } from '@/assets/js/common.js'
import customColumns from '@/components/common/customColumns.vue'
import { getLastElementForArr, getNextElementForArr, getPrevElementForArr } from '@/assets/js/orderEntering.js'
export default {
  props: {
    from: Object,
    power: Object,
    btnPower: Object
  },
  components: {
    customColumns
  },
  data () {
    return {
      store: this.$store.state,
      tableData: this.pushItem(),
      itemName: {
        submitName: "itemName",
        selected: {},
        valueIsObj: true,
        isMultiple: false,
        isAll: false,
        isShowAll: false,
        isFilterable: true,
        isRemote: true,
        isPagination: true,
        isReSearch: false,
        list: [],
        placeholder: "请选择商品",
        request: {
          url: "/Account/dataSearchVue/selectItemEnterDetailList.html",
          type: "post",
          params: {
            page: 1, size: 5,
            billType: this.from?.billType || '',
            keyWords: '',
            warehouseID: '',
            // searchType: 3
          },
          text: "itemName",
          value: "itemID",
        },
      },
      tableLoading: false,
      sum: {
        invCheckLossAmt: 0,
        invCheckProfitAmt: 0,
        totalAmt: 0,
        billInvQty: 0,
        billMedQty: 0,
        billSalQty: 0
      },
      viewInv: {
        loading: false,
        tableData: []
      },
      dialogVisible: false,
      uxGridHeight: 360,
      profitAndlossStatus: {
        A: { text: '盘亏', type: 'danger'},
        B: { text: '盘盈', type: 'success'},
        C: { text: '盘平', type: ''}
      },
      invCheckUsePrice: false,
      isShowCheckTotalAmt: false,
      priceArgs: {
          url: "/Account/dataSearchVue/getUserAllowCostPrice.html",
          code: 'isAllocateCheck'
      }
    }
  },
  directives: {
    focus: {
      inserted: function (el) {
        el.querySelector('input').onfocus = function () {
          this.select()
        }
        setTimeout(() => {
          el.querySelector('input').focus()
        }, 0)
      }
    }
  },
  computed: {
    customColumnList () {
      let tempItem = {}
      this.power.hideColumnList.forEach(i => {
        tempItem[i.prop] = i.isShow
      })
      return tempItem
    }
  },
  mounted () {
    this.uxGridHeight = parseInt($('.table').css('height'))
    window.onresize = () => {
      this.uxGridHeight = parseInt($('.table').css('height'))
    }
  },
  watch: {
    from (val) {
      this.itemName.request.params.warehouseID = val.warehouse.value
    },
    'store.power' (val) {
      this.invCheckUsePrice = val.invCheckUsePrice == 'A'
      this.isShowCheckTotalAmt = val.isShowCheckTotalAmt == 'Y'
      if(val.enterpriseVersion >= 100) {
        this.getPriceShow()
      }
      this.$nextTick(() => {
        this.$refs.table.doLayout()
      })
    }
  },
  methods: {
    getProductData() {
      this.tableData.some((item) => {
        if (!item.itemName) {
          this.tableCellClick(item, { property: 'itemName' })
          return true
        }
      })
    },
    pushItem (length = 20) {
      const tempItem = []
      for (let i = 0; i < length; i++) {
        tempItem.push({})
      }
      return tempItem
    },
    // 首字母大写
    titleCase(str) {
      return str.replace(/( |^)[a-z]/g, (L) => L.toUpperCase())
    },
    tableCellClick (row, { property }) {
      if (property && property.match(/itemName|salUnitQty|midUnitQty|invUnitQty|adjustQty4Sal|adjustQty4Mid|adjustQty4Inv|remark|productionDate/i)) {
        if (!this.from?.warehouse?.value) return this.$message({
          showClose: true,
          message: '请先选择仓库',
          type: 'warning'
        })
        if (!this.$parent?.$children[0]?.isCanEnter)  return this.$message({
          showClose: true,
          message: '请先审核其他盘点单',
          type: 'warning'
        })
        if (property == 'itemName') {
          this.$refs['table'].scrollToRow(row)
        }
        setTimeout(() => {
          row['isShow' + this.titleCase(property)] = true
          this.$refs['table'].updateData()
        }, 100)
        // this.$set(row, 'isShow' + this.titleCase(property), true)
      }
    },
    itemNameOptionKey(item) {
      return item.itemID + item.productionDate
    },
    itemNameVisibleChange(val, { row, column }, next) {
      if (!val) {
        if (next) {
          if (row.itemID) {
            this.$set(row, 'isShow' + this.titleCase(column.property), false)
          }
          this.tableCellClick(row, { property: next })
        } else {
          this.$set(row, 'isShow' + this.titleCase(column.property), false)
        }
      } else {
        this.$refs.table.$el.querySelector('.elx-table--body-wrapper').scrollLeft = 0
        this.itemName.placeholder = row.itemName
        this.itemName.selected = { text: row.itemName, value: row.itemID }
      }
      this.itemName.request.params.page = 1
    },
    async itemNameChange(val, { rowIndex: $index, row, column }, next) {
      let rowIndex = 0
      let rowItem = {}
      this.tableData.some((i, index) => {
        if (this.itemNameOptionKey(i) == this.itemNameOptionKey(val)) {
          rowIndex = index + 1
          rowItem = i
          return true
        }
      })
      let confirmResult = ''
      if (rowItem.itemID) {
        // if (this.$store.state.power.isAgreementDoubleItem == 'Y') {
        if (true) {
          const h = this.$createElement
          confirmResult = await this.$msgbox({
              title: '提示',
              message: h('p', null, [
                  h('i', { style: 'color: teal' }, rowItem.itemName),
                  h('span', null, '第'),
                  h('i', { style: 'color: #F56C6C' }, rowIndex),
                  h('span', null, '行已经录入，是否合并?')
              ]),
              showCancelButton: true,
              confirmButtonText: '合并',
              type: 'warning'
          }).catch(err => err)
        } else {
          this.$message({
            showClose: true,
            message: `${rowItem.itemName}在第${rowIndex}行已经录入`,
            type: 'warning'
          });
          row.isMerge = true
          row.mergeIndex = rowIndex
        }
      }
      if (confirmResult == '') {
        this.$set(this.tableData, $index, { ...row, ...val })
        let $queryForm = this.$parent.$children[0]
        $queryForm.selectProductList = $queryForm.selectProductList.filter(i => this.itemNameOptionKey(i) != this.itemNameOptionKey(row))
        // $queryForm.selectProductList = $queryForm.selectProductList.filter(i => i.value != row.value)
        $queryForm.selectProductList.push(val)
        this.itemNameVisibleChange(false, { row: this.tableData[$index], column }, next)
      } else if (confirmResult == 'confirm') {
        console.log(next);
        this.tableCellClick(rowItem, { property: next })
      }
    },
    async mergeRow({ rowIndex: $index, row }, next) {
      if (this.tableData.length <= 1) return
      const confirmResult = await this.$confirm('此操作为合并操作, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).catch(err => err)
      if (confirmResult !== 'confirm') return this.$message.info('取消合并')
      let index = row.mergeIndex - 1
      let item = this.tableData[index]
      if (item.itemID == row.itemID) {
        this.$set(this.tableData, $index, {})
        this.tableCellClick(this.tableData[index], { property: next })
      } else {
        // this.checkRepeat({ $index, row }, next)
      }
    },
    numberInputBlur ({ row }, property, next, index = null) {
      row['isShow' + this.titleCase(property)] = false
      // this.$set(this.tableData, $index , row)
      this.$refs['table'].updateData()
      if (next) {
        // if (property == 'remark') {
        //   if (this.tableData[$index + 1]) {
        //     this.tableCellClick(this.tableData[$index + 1], { property: next })
        //   }
        //   return false
        // }
        let tempRow = row
        if (index != null) {
          if (index >= 0) {
            tempRow = this.tableData[index]
          } else if (index < 0) {
            tempRow = this.tableData[getLastElementForArr(this.tableData, 'itemID')]
          }
          if (!tempRow.itemID) {
            next = 'itemName'
          }
        }
        this.tableCellClick(tempRow, { property: next })
      }
    },
    tableSelectUpOrDown({ row, rowIndex: $index }, property, index, key = 'itemID') {
      let idx = index
      if (idx >= 0) {
        if (idx >= this.tableData.length) {
          idx = 0
        }
      } else if (idx < 0) {
        idx = getLastElementForArr(this.tableData, key)
      }
      if (idx == -1) return false
      if (property == 'salUnitPrice') {
        if (index > $index) {
          idx = getNextElementForArr(this.tableData, key, idx)
          if (idx == -1) {
            idx = getLastElementForArr(this.tableData, 'itemID') + 1
          }
        } else if (index < $index) {
          idx = getPrevElementForArr(this.tableData, key, idx)
          if (idx == -1) {
            idx = getLastElementForArr(this.tableData, key)
          }
        }
      }
      this.$set(row, 'isShow' + this.titleCase(property), false)
      if (this.tableData[idx] && !this.tableData[idx].itemID) {
        property = 'itemName'
      }
      this.tableCellClick(this.tableData[idx], { property: property })
    },
    addRow (index) {
      if (index === this.tableData.length) {
        this.tableData = this.tableData.concat(this.pushItem(10))
      } else {
        // this.tableData.push({})
        this.tableData.splice(index, 0, {})
      }
    },
    async deleteRow ({ rowIndex: $index, row }) {
      if (this.tableData.length <= 1) return
      const confirmResult = await this.$confirm('此操作为删除操作, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).catch(err => err)
      if (confirmResult !== 'confirm') return this.$message.info('取消删除')
      this.$nextTick(() => {
        let $queryForm = this.$parent.$children[0]
        console.log(this.itemNameOptionKey(row))
        $queryForm.selectProductList = $queryForm.selectProductList.filter(i => this.itemNameOptionKey(i) != this.itemNameOptionKey(row))
        this.tableData.splice($index, 1)
      })
    },
    addProductToOrder (itemList) {
      if (this.power.activeName == 'third') {
        this.tableData.forEach(i => {
          itemList = itemList.filter(j => this.itemNameOptionKey(i) != this.itemNameOptionKey(j))
        })
      }
      let tableData = [ ...this.tableData ].reverse()
      let length = tableData.length
      this.$nextTick(() => {
        tableData.some((item, index) => {
          if (item.itemID) {
            itemList.forEach((row, $index) => {
              this.$set(this.tableData, length - index + $index, row)
            })
            return true
          }
          if ((this.tableData.length - 1) == index) {
            itemList.map((row, $index) => {
              this.$set(this.tableData, $index, row)
            })
            return true
          }
        })
      })
      return true
    },
    deleteProductToOrder (key, value, itemList = []) {
      this.$nextTick(() => {
        if (itemList.length > 0) {
          itemList.forEach(item => {
            // this.tableData = this.tableData.filter(i => i.itemID != item.itemID)
            this.tableData = this.tableData.filter(i => this.itemNameOptionKey(i) != this.itemNameOptionKey(item))
          })
        } else {
          this.tableData = this.tableData.filter(item => item[key] != value)
        }
        this.tableData = this.tableData.concat(this.pushItem(20 - this.tableData.length))
      })
      return true
    },
    clearTable() {
      let $queryForm = this.$parent.$children[0]
      $queryForm.selectProductList = []
      this.tableData = [].concat(this.pushItem(20))
    },
    inventory (tag, { row }) {
      this.$set(row, 'salUnitQty', tag == 2 ? 0 : row.onhandQty4Sal)
      this.$set(row, 'midUnitQty', tag == 2 ? 0 : row.onhandQty4Mid)
      this.$set(row, 'invUnitQty', tag == 2 ? 0 : row.onhandQty4Inv)
      this.numberInputChange(null, { row })
      if (tag == 0) this.$set(row, 'checkedStatus', 'N')
    },
    async getPriceShow() {
      const { data: res } = await this.$http.post(this.priceArgs.url, this.Qs.stringify(this.priceArgs))
      if(this.isShowCheckTotalAmt){
        if(this.invCheckUsePrice){
          this.isShowCheckTotalAmt = res.result == 'Y'
        }else {
          this.isShowCheckTotalAmt = true
        }
      }else {
        this.isShowCheckTotalAmt = false
      }
    },
    numberInputChange (val, { row }, tag = '') {
      let { salUnitConversion = 0, midUnitConversion = 0, salUnitQty = 0, midUnitQty = 0, invUnitQty = 0, onhandQty4Inv = 0, onhandQty4Mid = 0, onhandQty4Sal = 0, adjustQty4Sal = 0, adjustQty4Mid = 0, adjustQty4Inv = 0, invUnitPrice = 0, availableQty = 0 } = row
      let sal = 0, mid = 0, inv = 0, realQty = 0, adjustQty = 0
      // 将折算小单位数量inv重新分配给大中小单位
      let invTransformationt = (inv = 0) => {
        let arr = [Number(salUnitConversion)]
        if (Number(midUnitConversion)) {
          arr.push(Number(midUnitConversion))
        }
        return arr.reduce(({ salTran, midTran, invTran }, item, index) => {
          /**
            * 有大单位转换比:
            * 1.大单位数量 = （折算小单位数量/大单位转换比）取整
            * 1.1 如果大单位有小数位，小单位数量 = 小数位*大单位转换比
            * 1.2 如果没有小数位，小单位数量 = 0
            * 有中单位转换比
            * 1.中单位数量 = （1.1计算的小单位数量/中单位转换比）取整
            * 1.1 如果中单位有小数位，小单位数量 = 小数位*中单位转换比
            * 1.2 如果没有小数位，小单位数量 = 0
            */
          if (index == 0) {
            let tempSal = (invTran / item)
            salTran = Math.trunc(tempSal)
            // 获取tempSal的小数点后的数
            let fractSal = (tempSal - salTran)
            invTran = Math.abs(fractSal) ? (fractSal * item) : 0
          } else if (index == 1) {
            let tempMid = (invTran / item)
            midTran = Math.trunc(tempMid)
            // 获取tempMid的小数点后的数
            let fractMid = (tempMid - midTran)
            invTran = Math.abs(fractMid) ? (fractMid * item) : 0
          }
          return { salTran: Number(salTran.toFixedRoundUp(2)), midTran: Number(midTran.toFixedRoundUp(2)), invTran: Number(invTran.toFixedRoundUp(2)) }
        }, { salTran: 0, midTran: 0, invTran: inv })
      }
      if (tag == 'adjustQty') {
        sal = (Number(adjustQty4Sal) + Number(onhandQty4Sal)) * Number(salUnitConversion)
        mid = (Number(adjustQty4Mid) + Number(onhandQty4Mid)) * Number(midUnitConversion)
        inv = Number(adjustQty4Inv) + Number(onhandQty4Inv)
        realQty = Number(toFixedRe((sal + mid + inv), 2))
        adjustQty = Number(adjustQty4Sal) * Number(salUnitConversion) + Number(adjustQty4Mid) * Number(midUnitConversion) + Number(adjustQty4Inv)
        let adjustTran = invTransformationt(adjustQty)
        let realTran = invTransformationt(realQty)
        if (salUnitConversion == 1) {
          this.$set(row, 'salUnitQty', realQty)
          this.$set(row, 'adjustQty4Sal', adjustQty)
        } else {
          this.$set(row, 'salUnitQty', realTran.salTran)
          this.$set(row, 'midUnitQty', realTran.midTran)
          this.$set(row, 'invUnitQty', realTran.invTran)
          this.$set(row, 'adjustQty4Sal', adjustTran.salTran)
          this.$set(row, 'adjustQty4Mid', adjustTran.midTran)
          this.$set(row, 'adjustQty4Inv', adjustTran.invTran)
        }

        // this.$set(row, 'salUnitQty', Number(toFixedRe((Number(adjustQty4Sal) + Number(onhandQty4Sal)), 2)))
        // this.$set(row, 'midUnitQty', Number(toFixedRe((Number(adjustQty4Mid) + Number(onhandQty4Mid)), 2)))
        // this.$set(row, 'invUnitQty', Number(toFixedRe((inv), 2)))
      } else {
        sal = (Number(salUnitQty) - Number(onhandQty4Sal)) * Number(salUnitConversion)
        mid = (Number(midUnitQty) - Number(onhandQty4Mid)) * Number(midUnitConversion)
        inv = Number(invUnitQty) - Number(onhandQty4Inv)
        realQty = Number(salUnitQty) * Number(salUnitConversion) + Number(midUnitQty) * Number(midUnitConversion) + Number(invUnitQty)
        adjustQty = Number(toFixedRe((sal + mid + inv), 2))
        let adjustTran = invTransformationt(adjustQty)
        let realTran = invTransformationt(realQty)
        if (salUnitConversion == 1) {
          this.$set(row, 'salUnitQty', realQty)
          this.$set(row, 'adjustQty4Sal', adjustQty)
        } else {
          this.$set(row, 'salUnitQty', realTran.salTran)
          this.$set(row, 'midUnitQty', realTran.midTran)
          this.$set(row, 'invUnitQty', realTran.invTran)
          this.$set(row, 'adjustQty4Sal', adjustTran.salTran)
          this.$set(row, 'adjustQty4Mid', adjustTran.midTran)
          this.$set(row, 'adjustQty4Inv', adjustTran.invTran)
        }
        // this.$set(row, 'adjustQty4Sal', Number(toFixedRe((Number(salUnitQty) - Number(onhandQty4Sal)), 2)))
        // this.$set(row, 'adjustQty4Mid', Number(toFixedRe((Number(midUnitQty) - Number(onhandQty4Mid)), 2)))
        // this.$set(row, 'adjustQty4Inv', Number(toFixedRe((inv), 2)))
      }
      let amt = Number(toFixedRe(adjustQty * Number(invUnitPrice), 2))
      let profitAndlossStatus = 'C'
      if (adjustQty > 0) {
        profitAndlossStatus = 'B'
      } else if (adjustQty < 0) {
        profitAndlossStatus = 'A'
      } else if (adjustQty == 0) {
        profitAndlossStatus = 'C'
      }
      this.$set(row, 'checkedStatus', 'Y')
      this.$set(row, 'adjustQty', adjustQty)
      this.$set(row, 'amt', amt)
      this.$set(row, 'realQty', realQty)
      this.$set(row, 'profitAndlossStatus', profitAndlossStatus)
      this.computedInventory()
    },
    computedInventory () {
      let billInvQty = 0, billMedQty = 0, billSalQty = 0, invCheckLossAmt = 0, invCheckProfitAmt = 0
      this.tableData.forEach(item => {
        let amt = Number(item.amt || 0)
        if (amt > 0) {
          invCheckProfitAmt += amt
        } else {
          invCheckLossAmt += amt
        }
        billSalQty += Number(item.salUnitQty || 0)
        billMedQty += Number(item.midUnitQty || 0)
        billInvQty += Number(item.invUnitQty || 0)
      })
      this.sum.billInvQty = Number(toFixedRe((billInvQty), 2))
      this.sum.billMedQty = Number(toFixedRe((billMedQty), 2))
      this.sum.billSalQty = Number(toFixedRe((billSalQty), 2))
      this.sum.invCheckProfitAmt = Number(toFixedRe((invCheckProfitAmt), 2))
      this.sum.invCheckLossAmt = Number(toFixedRe((invCheckLossAmt), 2))
      this.sum.totalAmt = Number(toFixedRe((invCheckProfitAmt + invCheckLossAmt), 2))
    },
    async submitOrser (params) {
      let { deliverUser, salesman, warehouse, remark } = this.from
      if (!warehouse?.value) return this.$message({
        showClose: true,
        message: '请先选择仓库',
        type: 'warning'
      })
      if (!salesman?.value) return this.$message({
        showClose: true,
        message: '请先选择业务员',
        type: 'warning'
      })
      if (!deliverUser?.value) return this.$message({
        showClose: true,
        message: '请先选择盘点人',
        type: 'warning'
      })
      if (!this.$parent?.$children[0]?.isCanEnter) return this.$message({
        showClose: true,
        message: '请先审核其他盘点单',
        type: 'warning'
      })
      if (!this.tableData.length) return this.$message({
        showClose: true,
        message: '请先至少录入一条数据',
        type: 'warning'
      })
      const loading = this.$loading({
        lock: true,
        text: '保存中，请耐心等待',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      let currTab = '', title = ''
      if (top.$('#tabspanel .tabs-selected').text()) {
        currTab = top.$('#tabspanel').tabs('getSelected') || ''
        title = top.$('#tabspanel .tabs-selected').text() || ''
      } else {
        title = top.getTabName() || ''
        currTab = top.getTabName() || ''
      }
      let { totalAmt, invCheckLossAmt, invCheckProfitAmt, billInvQty, billMedQty, billSalQty } = this.sum
      let invCheckWay = ''
      if (this.power.activeName == 'first') {
        invCheckWay = 'A'
      } else if (this.power.activeName == 'second') {
        invCheckWay = 'B'
      } else if (this.power.activeName == 'third') {
        invCheckWay = this.power.empty
      } else if (this.power.activeName == 'fourth') {
        invCheckWay = 'E'
      }
      let headInfo = {
        entryUserID: deliverUser.value,
        entryUserName: deliverUser.text,
        checkUserID: deliverUser.value,
        checkUserName: deliverUser.text,
        warehouseID: warehouse.value,
        warehouseName: warehouse.text,
        salesmanID: salesman.value,
        salesmanName: salesman.text,
        remark,
        totalAmt,
        invCheckLossAmt,
        invCheckProfitAmt,
        billInvQty,
        billMedQty,
        billSalQty,
        invCheckWay
      }
      let tableData = []
      this.tableData.map((i, index) => {
        if (i.itemID) {
          i['lineNum'] = index + 1
          tableData.push(i)
        }
      })
      let url = '', { tag, billNo } = this.power
      if (billNo) headInfo['billNo'] = billNo
      if (params == 0) {
        url = tag && tag != 'copy' ? '/Account/InvCheckVue/updateInvCheck.html' : '/Account/InvCheckVue/addInvCheck.html'
      } else {
        url = tag && tag != 'copy' ? '/Account/InvCheckVue/updateRecordCheck.html' : '/Account/InvCheckVue/addRecordCheck.html'
      }
      const { data: res } = await this.$http.post(url, this.Qs.stringify({
        headInfo: JSON.stringify(headInfo),
        itemList: JSON.stringify(tableData)
      }))
      loading.close()
      if (res.code != 'success') return this.$message.error(res.message)
      this.$message.success(res.message)
      if (params == 0 && false) {
        if (!tag) {
          let { data: result } = JSON.parse(res.result, (key, value) => {
            if (key == 'data') {
              return JSON.parse(value)
            } else {
              return value
            }
          })
          top.refreshTabWithUrl(`/templates/vue-account/dist/index.htm#/inventory?billNo=${ result.billNo }&tag=edit&invCheckWay=${ invCheckWay }`, currTab)
        } else if (tag == 'copy') {
          let width = top.document.browser.availiframeWidth.value,
              height = top.document.browser.availiframeHeight.value
          top.addPanel('盘点录单查看', `/Account/sys/salConsign/salQuery.html?tag=PKD&billType=A&invCheckWay=${ invCheckWay }`, width, height, true)
          top.closedPanel(title)
        } else if (tag == 'edit') {
          top.refreshTabWithUrl(`/templates/vue-account/dist/index.htm#/inventory?billNo=${ billNo }&tag=edit&invCheckWay=${ invCheckWay }`, currTab)
        }
      } else {
        top.refreshTabWithUrl(`/templates/vue-account/dist/index.htm?v=${Math.random()}#/inventory?invCheckWay=${ invCheckWay }`, currTab)
      }
    },
    async viewInvNum ({ itemID, productionDate }) {
      this.viewInv.loading = true
      const { data: res } = await this.$http.post('/Account/InvCheckVue/selectLastInvCheckInfoByItemID.html', this.Qs.stringify({
        warehouseID: this.from?.warehouse?.value,
        itemID,
        productionDate
      }))
      this.viewInv.loading = false
      if (res.code != 'success') return this.$message.error(res.message)
      this.viewInv.tableData = JSON.parse(JSON.parse(res.result).data)
    },
    getCustomColumns () {
      this.dialogVisible = true
      let tempArr = [ ...this.power.hideColumnList ]
      this.$nextTick(() => {
        let element = this.$refs['customColumns']
        element.loading = false
        element.setCustomcolumns(tempArr)
      })
    },
    dialogClose (isSubmit) {
        if(!isSubmit){
            this.dialogVisible = false
            return
        }
      let $customColumns = this.$refs['customColumns']
      $customColumns.$nextTick(async () => {
        let { customColumns } = $customColumns
        const { data: res } = await this.$http.post('/Account/customerColumnDefineVue/saveColAndAuthByFuncCode.html', this.Qs.stringify({
          funcCode: 208,
          customSetInfo: JSON.stringify(customColumns)
        }))
        if (res.code != 'success') return this.$message.error(res.message)
        this.$message.success(res.message)
        this.dialogVisible = false
        this.$emit('getCustomColumn')
      })

    },
    async productionDateChange (val, { row, rowIndex: $index }) {
      const { data: res } = await this.$http.post('/Account/dataSearchVue/selectItemEnterDetailList.html', this.Qs.stringify({
        billType: 'PKD',
        warehouseID: this.from.warehouse.value || '',
        productionDate: val,
        itemID: row.itemID,
        searchType: 3,
      }))
      if (res.code != 'success') return this.$message.error(res.message)
      let tempArr = JSON.parse(JSON.parse(res.result).data)
      if (tempArr.length == 0) return
      tempArr[0]['productionDate'] = val
      this.$set(this.tableData, $index, { ...row, ...tempArr[0] })
    },
    viewInvOnLoadQty ({ itemName, itemID, productionDate }) {
      let width = window.top.document.browser.availiframeWidth.value
      let height = window.top.document.browser.availiframeHeight.value
      let warehouseID = this.from?.warehouse?.value
      let warehouseName = this.from?.warehouse?.text
      top.addPanel('订单占用查询', `/templates/vue-account/dist/index.htm#/orderOccupy?${ this.Qs.stringify({ itemName, itemID, warehouseID, warehouseName, productionDate }) }`, width, height, true)
      // this.$router.push({ path: '/orderOccupy', query: { itemName, itemID, warehouseID, warehouseName, productionDate } })
    },
    tips: debounce((row, _this) => {
      _this.$confirm('调整的出库数量大于库存可用量,请处理掉该商品有订单占用的订单', '提示', {
        showConfirmButton: false,
        type: 'warning'
      }).catch(err => err)
      _this.$set(row, 'salUnitQty', row.onhandQty4Sal)
      _this.$set(row, 'midUnitQty', row.onhandQty4Mid)
      _this.$set(row, 'invUnitQty', row.onhandQty4Inv)
    }, 300, true),
    tableRowClassName ({ row, rowIndex }) {
      if (row.isSearch) {
        return 'search-row'
      }
      return ''
    },
    // 自定义筛选
    tableFilter (input) {
      let reg = new RegExp(input, 'i')
      let flag = true, $index = 0
      // const matchFn = (tag) => {
      //   if (tag) {
      //     if (toRawType(tag) == 'String') {
      //       return tag.match(reg)
      //     } else if (toRawType(tag) == 'Number') {
      //       return tag.toString().match(reg)
      //     } else {
      //       return false
      //     }
      //   }
      //   return false
      // }
      // const condition = i => {
      //   // return input && i.itemName && (i.itemName.match(reg) || Number(i.midBarCode || 0).toString().match(reg) || Number(i.salBarCode || 0).toString().match(reg) || Number(i.invBarCode || 0).toString().match(reg) || i.helpCode.toString().match(reg) || i.itemCode.match(reg))
      //   return input && i.itemName && (matchFn(i.itemName) || matchFn(i.salBarCode) || matchFn(i.midBarCode) || matchFn(i.invBarCode) || matchFn(i.helpCode) || matchFn(i.itemCode))
      // }
      const condition = i => {
        return input && i.itemName && (i.itemName.match(reg) || Number(i.midBarCode || 0).toString().match(reg) || Number(i.salBarCode || 0).toString().match(reg) || Number(i.invBarCode || 0).toString().match(reg) || (i.helpCode || '').toString().match(reg) || (i.itemCode || '').match(reg))
      }
      this.tableData.forEach((i, index) => {
        if (condition(i)) {
          if (flag) {
            $index = index
            flag = false
          }
          i.isSearch = true
        } else {
          i.isSearch = false
        }
      })
      // this.$tableScrollMove('table', $index)
      this.$refs['table'].scrollToRow(this.tableData[$index])
      this.$refs['table'].updateData()
    },
    /**
     * @description: 通过表格索引 定位表格的位置
     */
    $tableScrollMove(refName, index = 0){
      if(!refName || !this.$refs[refName]) return//不存在表格的ref vm 则返回
      let vmEl = this.$refs[refName].$el
      if(!vmEl) return
      //计算滚动条的位置
      const targetTop = vmEl.querySelectorAll('.el-table__body tr')[index].getBoundingClientRect().top
      const containerTop = vmEl.querySelector('.el-table__body').getBoundingClientRect().top
      const scrollParent = vmEl.querySelector('.el-table__body-wrapper')
      scrollParent.scrollTop = targetTop - containerTop
    },
    diskEmpty() {
      this.tableData.forEach(item => {
        this.inventory(2, { row: item })
      })
    }
  }
}
</script>
<style lang="less">
.el-select-group__title~.el-select-dropdown__item {
  height: auto !important;
}
</style>
<style scoped lang="less">
.app {
  height: calc(100% - 66px);
  .table {
    width: 100%;
    height: calc(100% - 45px);
    ::v-deep .elx-cell {
      padding: 0;
      .iconfont {
        font-size: 14px;
      }
    }
    ::v-deep .elx-table {
      .elx-body--column, 
      .elx-footer--column.col--ellipsis {
        height: 70px;
      }
      .elx-body--column.col--ellipsis>.elx-cell,
      .elx-footer--column.col--ellipsis>.elx-cell {
        max-height: 70px;
      }
      .table-index {
        font-size: 12px;
      }
      th, td, .cell {
        padding: 0;
      }
      thead {
        color: #606266;
      }
      .qty-wrap {
        border-bottom: 1px solid #EBEEF5;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: center;
      }
      .qty-input {
        width: 48px;
        .el-input__inner {
          padding: 0;
          text-align: left;
        }
      }
      .qty {
        display: inline-block;
        min-width: 48px;
        text-align: center;
      }
      .search-row {
        td {
          background-color: rgba(64, 158, 255, 0.6);
          color: #fff;
        }
      }
    }
  }
  .footer {
    height: 45px;
    display: flex;
    align-items: center;
    margin-top: 6px;
    span {
      width: 50%;
      .text {
        font-size: 20px;
        color: #F56C6C;
        padding: 0 4px;
      }
    }
    div {
      transform: translate(-50%, 0);
    }
  }
  ::v-deep .el-dialog {
    .el-dialog__body {
      padding: 16px 12px 30px;
    }
    .el-dialog__footer {
      text-align: center;
    }
  }
  .reference {
    cursor: pointer;
  }
  .reference.highlight label {
    color: #409EFF;
  }
}
.query_btn_group {
  display: flex;
  .el-button {
    margin-left: 6px;
    color: #606266;
    &:hover {
      color: #409EFF;
    }
  }
}
</style>